import * as z from "zod";

export const ProductsGeneralFlatTeamSettingsSchema = z.object({
  "products/hazmat/lithiumBattery/tagsInclude": z.array(z.string()).nullish(),
});
